import { useSelector } from 'react-redux';

export const useRoleActive = (targetRole) => {
  const { data: roles } = useSelector(state => state.allRoles);
  return !!roles.find((role) => role.role === targetRole)?.is_active;
};